module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    class: _vm.tableClass,
    attrs: {
      "id": _vm.id || null,
      "aria-busy": _vm.computedBusy ? 'true' : 'false'
    }
  }, [_c('thead', {
    class: _vm.headClass
  }, [_c('tr', _vm._l((_vm.computedFields), function(field, key) {
    return _c('th', {
      key: key,
      class: _vm.fieldClass(field, key),
      style: (field.thStyle || {}),
      attrs: {
        "aria-label": field.sortable ? ((_vm.localSortDesc && _vm.localSortBy === key) ? _vm.labelSortAsc : _vm.labelSortDesc) : null,
        "aria-sort": (field.sortable && _vm.localSortBy === key) ? (_vm.localSortDesc ? 'descending' : 'ascending') : null,
        "tabindex": field.sortable ? '0' : null
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.headClicked($event, field, key)
        },
        "keydown": [function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.stopPropagation();
          $event.preventDefault();
          _vm.headClicked($event, field, key)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
          $event.stopPropagation();
          $event.preventDefault();
          _vm.headClicked($event, field, key)
        }]
      }
    }, [_vm._t('HEAD_' + key, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(field.label)
      }
    })], {
      label: field.label,
      column: key,
      field: field
    })], 2)
  }))]), _vm._v(" "), (_vm.footClone) ? _c('tfoot', {
    class: _vm.footClass
  }, [_c('tr', _vm._l((_vm.computedFields), function(field, key) {
    return _c('th', {
      key: key,
      class: _vm.fieldClass(field, key),
      style: (field.thStyle || {}),
      attrs: {
        "aria-label": field.sortable ? ((_vm.localSortDesc && _vm.localSortBy === key) ? _vm.labelSortAsc : _vm.labelSortDesc) : null,
        "aria-sort": (field.sortable && _vm.localSortBy === key) ? (_vm.localSortDesc ? 'descending' : 'ascending') : null,
        "tabindex": field.sortable ? '0' : null
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.headClicked($event, field, key)
        },
        "keydown": [function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.stopPropagation();
          $event.preventDefault();
          _vm.headClicked($event, field, key)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
          $event.stopPropagation();
          $event.preventDefault();
          _vm.headClicked($event, field, key)
        }]
      }
    }, [(_vm.$scopedSlots['FOOT_' + key]) ? _vm._t('FOOT_' + key, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(field.label)
      }
    })], {
      label: field.label,
      column: key,
      field: field
    }) : _vm._t('HEAD_' + key, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(field.label)
      }
    })], {
      label: field.label,
      column: key,
      field: field
    })], 2)
  }))]) : _vm._e(), _vm._v(" "), _c('tbody', [(_vm.$scopedSlots['top-row']) ? _c('tr', [_vm._t("top-row", null, {
    columns: _vm.keys(_vm.fields).length,
    fields: _vm.fields
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedItems), function(item, index) {
    return _c('tr', {
      key: index,
      class: _vm.rowClass(item),
      on: {
        "click": function($event) {
          _vm.rowClicked($event, item, index)
        },
        "dblclick": function($event) {
          _vm.rowDblClicked($event, item, index)
        },
        "mouseenter": function($event) {
          _vm.rowHovered($event, item, index)
        }
      }
    }, [_vm._l((_vm.computedFields), function(field, key) {
      return [_c('td', {
        key: key,
        class: _vm.tdClass(field, item, key)
      }, [_vm._t(key, [_vm._v(_vm._s(item[key]))], {
        value: item[key],
        item: item,
        index: index
      })], 2)]
    })], 2)
  }), _vm._v(" "), (_vm.showEmpty && (!_vm.computedItems || _vm.computedItems.length === 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.keys(_vm.computedFields).length
    }
  }, [(_vm.filter) ? _c('div', {
    attrs: {
      "role": "alert",
      "aria-live": "polite"
    }
  }, [_vm._t("emptyfiltered", [_c('div', {
    staticClass: "text-center my-2",
    domProps: {
      "innerHTML": _vm._s(_vm.emptyFilteredText)
    }
  })])], 2) : _c('div', {
    attrs: {
      "role": "alert",
      "aria-live": "polite"
    }
  }, [_vm._t("empty", [_c('div', {
    staticClass: "text-center my-2",
    domProps: {
      "innerHTML": _vm._s(_vm.emptyText)
    }
  })])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.$scopedSlots['bottom-row']) ? _c('tr', [_vm._t("bottom-row", null, {
    columns: _vm.keys(_vm.fields).length,
    fields: _vm.fields
  })], 2) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6784be7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/lib/components/table.vue
// module id = 232
// module chunks = 1